<template>
  <v-container>
    <h2 class="text-uppercase">{{ title }}</h2>
    <v-divider></v-divider>
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      :label="$t('common.search')"
      single-line
      hide-details
      style="margin: 0rem 2rem"
    ></v-text-field>

    <v-data-table
      :headers="headers"
      :items="data"
      :loading="loading"
      :items-per-page="50"
      class="elevation-1"
      :search="search"
      @click:row="clickedRow"
    >
      <template
        v-for="slot in Object.keys($scopedSlots)"
        :slot="slot"
        slot-scope="scope"
        ><slot :name="slot" v-bind="scope"
      /></template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  name: "NiceDataTable",

  props: {
    data: Array,
    ignore: Array,
    languagePrefix: String,
    loading: Boolean,
    title: String,
    actions: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      search: "",
      headers: [],
    };
  },

  methods: {
    clickedRow(item) {
      this.$emit("clicked-row", item);
    },
  },

  created() {
    if (this.data.length > 0) {
      Object.keys(this.data[0]).forEach((key) => {
        if (!this.ignore.includes(key)) {
          this.headers.push({
            text: this.$t(this.languagePrefix + key),
            value: key,
          });
        }
      });

      if (this.actions) {
        this.headers.push({
          text: this.$t(this.languagePrefix + "actions"),
          value: "actions",
        });
      }
    }
  },

  watch: {
    data() {
      if (this.data.length > 0) {
        this.headers = [];
        Object.keys(this.data[0]).forEach((key) => {
          if (!this.ignore.includes(key)) {
            this.headers.push({
              text: this.$t(this.languagePrefix + key),
              value: key,
            });
          }
        });

        if (this.actions) {
          this.headers.push({
            text: this.$t(this.languagePrefix + "actions"),
            value: "actions",
          });
        }
      }
    },
  },
};
</script>
